var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-autocomplete', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form.hour,
      callback: function ($$v) {
        _vm.$set(_vm.form, "hour", $$v);
      },
      expression: "form.hour"
    }
  }, 'v-autocomplete', Object.assign({}, _vm.$attrs, {
    items: _vm.items
  }), false));

}
var staticRenderFns = []

export { render, staticRenderFns }